<script setup>
import carteMalinNonValide from "@/assets/images/carte-malin-non-valide.png";
import carteCoraNonValide from "@/assets/images/mastercard-cora-non-valide.png";
</script>
<script>
import Popin from "@/containers/popin-adaptive";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";

export default {
  name: "PopinCarteInvalide",
  components: { Popin, LazyImage, Button },
  props: {
    typeCarte: {
      type: String,
      required: false,
      default: "malin"
    }
  },
  computed: {
    pathImage() {
      return this.typeCarte === "malin"
        ? carteMalinNonValide
        : carteCoraNonValide;
    }
  },
  methods: {
    show() {
      this.$refs.popin.show();
    },
    hide() {
      this.$refs.popin.hide();
    },
    goToProfil() {
      this.hide();
      navigateToInternal("/mon-compte/ma-fidelite");
    },
    goToFormulaire() {
      this.hide();
      navigateToInternal("/creation-carte-fidelite");
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    aria-label="Carte invalide"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
  >
    <div class="u-flex u-flex-align-center u-flex-justify-center u-mb-sm">
      <LazyImage
        :src="pathImage"
        :alt="`Carte ${typeCarte}`"
        width="98"
        height="68"
      />
    </div>
    <div>
      <h1 class="u-font-secondary u-color-primary u-font-24 u-font-700 u-text-center u-mb-sm">
        Cette carte {{ typeCarte }} n’est pas valide
      </h1>
      <p>
        Nous n'avons pas trouvé de numéro de fidélité correspondant.
        <br>
        Les raisons possibles :
      </p>
      <br>
      <p>
        <strong>Votre carte est inactive</strong><br>
        Rendez-vous au village des services de votre magasin.
      </p>
      <p>
        <strong>Votre carte est récente et son enregistrement n’est pas encore effectif</strong><br>
        Enregistrez-là ultérieurement.
      </p>
    </div>
    <div class="u-pt-lg u-pb-sm u-flex u-flex-justify-center u-flex-align-center u-flex-column-reverse@md">
      <Button
        v-if="typeCarte === 'malin'"
        outline
        variant="primary"
        radius="full"
        size="md"
        class="u-mt-sm@md u-mr-sm u-mr-none@md"
        @click="goToFormulaire()"
      >
        Nous contacter
      </Button>
      <Button
        variant="primary"
        radius="full"
        size="md"
        @click="goToProfil()"
      >
        Je saisis un autre numéro
      </Button>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
